export enum ActivityLogsType {
  ACCOUNT = "account",
  CLOUD_APPS = "cloudApps",
  DEVICE = "device",
  DLP = "dlp",
  DEVICE_DLP = "deviceDlp",
  EMAIL = "email",
  MALWARE = "malware",
  PHISHING = "phishing",
  UNDO = "undo",
  USERS = "users",
  BILLING = "billing",
  DETECTION_LOGS = "detectionLogs",
  CSV_EXPORT = "csvExport",
  SYSLOGS = "syslogConfigs",
  WORKSPACE = "workspace",
  MSP = "msp",
  SIEM_CONFIG = "siemConfig",
  SIEM_CONFIGS = "siemConfigs",
  API_CREDENTIALS = "apiCredentials",
  WORKSPACE_REPORT = "workspaceReport",
  WORKSPACE_SCHEDULED_REPORT = "workspaceScheduledReport",
  SOC = "soc",
  MOBILE = "mobile",
  PSA = "psa",
  WEBHOOK = "webhook",
  SECURITY_AWARENESS = "securityAwareness",
  SECURITY_GAPS = "securityGaps",
  MSP_POLICY = "mspPolicy",
  MDM_DEVICE = "mdmDevice",
  MDM_ACTION = "mdmAction",
  MDM_DEVICE_ACTION = "mdmDeviceAction",
  MDM_SYSTEM = "mdmSystem",
  THIRD_PARTY_APPS = "thirdPartyApp",
  CLOUD_BACKUP = "backupAndRestore",
}
